export default {"src":"https://assets.madeeasy.in/prod/_next/static/media/clarity_date-solid.1fe1500d.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};